import { createSelector } from "reselect";
import { getKaMetlhaFuneralCover } from "./index";
import { PAGE_INDICES } from "../../actions/kaMetlhaFuneralCover/types";

export const getRouting = createSelector(
  getKaMetlhaFuneralCover,
  (kaMetlhaFuneralCover) => kaMetlhaFuneralCover.routing
);
export const getActivePageIndex = createSelector(
  getRouting,
  (routing) => routing.activePageIndex
);
export const getScrollToId= createSelector(
  getRouting,
  (routing) => routing.scrollToId
);


export const makeGetIsPage = (pageIndex) =>
  createSelector(
    getRouting,
    (routing) => routing.activePageIndex === pageIndex
  );

export const getIsReplacementPolicyPage = makeGetIsPage(
  PAGE_INDICES.REPLACEMENT_POLICY
);
export const getIsPersonalDetailsPage = makeGetIsPage(
  PAGE_INDICES.PERSONAL_DETAILS
);
export const getIsLivesCoveredPage = makeGetIsPage(
  PAGE_INDICES.LIVES_COVERED
);
export const getIsBeneficiaryPage = makeGetIsPage(
  PAGE_INDICES.BENEFICIARIES
);
export const getIsPaymentDetailsPage = makeGetIsPage(
  PAGE_INDICES.PAYMENT_DETAILS
);
export const getIsUplaoadDocumentsPage = makeGetIsPage(
  PAGE_INDICES.UPLOAD_DOCUMENTS
);
export const getIsConfirmationPage = makeGetIsPage(
  PAGE_INDICES.CONFIRMATION
);
export const getIsThankYouPage = makeGetIsPage(PAGE_INDICES.THANK_YOU);

export const getProgressBarIndex = createSelector(
  getIsReplacementPolicyPage,
  getIsPersonalDetailsPage,
  getIsLivesCoveredPage,
  getIsBeneficiaryPage,
  getIsPaymentDetailsPage,
  getIsConfirmationPage,
  getIsUplaoadDocumentsPage,
  (
    isReplacementPolicyPage,
    isPersonalDetailsPage,
    isLivesCovered,
    isBeneficiary,
    isPaymentDetailsPage,
    isConfirmationPage,
    isUploadDocumentsPage
  ) => {
    if (isReplacementPolicyPage) {
      return -1;
    }
    if (isPersonalDetailsPage) {
      return 0;
    }
    if (isLivesCovered) {
      return 1;
    }
    if (isBeneficiary) {
      return 2;
    }
    if (isPaymentDetailsPage) {
      return 3;
    }
    if (isUploadDocumentsPage) {
      return 4;
    }

    if (isConfirmationPage) {
      return 5;
    }
  }
);

// used by the application wizard footer
export const getContinueButtonText = createSelector(
  getActivePageIndex,
  (activePageIndex) => {
    return activePageIndex === PAGE_INDICES.CONFIRMATION
      ? "SUBMIT"
      : "CONTINUE";
  }
);

// used by the application wizard header
// TODO: Implement page types and remove magic numbers
export const getHideDesktop = createSelector(
  getActivePageIndex,
  (activePageIndex) => {
    return activePageIndex < 1 || activePageIndex === 5;
  }
);

// used by the application wizard header
// TODO: Implement page types and remove magic numbers
export const getHideMobile = createSelector(
  getActivePageIndex,
  (activePageIndex) => {
    return activePageIndex === 7;
  }
);
